/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<898e223eeac519d9d67f177f048c3a32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type HelpLayoutForgeElementPages = "approvals" | "create_request" | "help_center" | "my_requests" | "portal" | "profile" | "view_request" | "%future added value";
export type HelpLayoutForgeElementType = "FOOTER" | "HEADER_AND_SUBHEADER" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type forgeElementFragment$data = {
  readonly forgeElementPage: HelpLayoutForgeElementPages;
  readonly forgeElementType: HelpLayoutForgeElementType;
  readonly " $fragmentType": "forgeElementFragment";
};
export type forgeElementFragment$key = {
  readonly " $data"?: forgeElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"forgeElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "forgeElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forgeElementType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forgeElementPage",
      "storageKey": null
    }
  ],
  "type": "HelpLayoutForgeElement",
  "abstractKey": null
};

(node as any).hash = "7cbd50b7d297d1d7e5a2129168127d6e";

export default node;
